import React, { useEffect, useState } from "react";
import _ from "lodash";
import {
  Typography,
} from "design_system/src";
import { useDispatch } from "react-redux";
import useCurrentCity from "hooks/useCurrentCity";
import { Swiper, SwiperSlide } from "swiper/react";
import Swipercore, { Navigation, Pagination, Autoplay } from "swiper";
import { TVehicle } from "models/inventory/interfaces/vehicle.interface";
import { getVehiclesRecommended } from "models/inventory/controllers/vehicle.controller";
import VehicleItem from "./VehicleItem";
import styles from "./RecommendedVehicles.module.scss";
import RecommendedVehiclesSkeleton from "./RecommendedVehiclesSkeleton";


const LIMIT = 6;
const RecommendedVehicles: React.FC<{}> = () => {
  Swipercore.use([Navigation, Pagination, Autoplay]);
  const dispatch = useDispatch();
  const city = useCurrentCity();
  const [vehicles, setVehicles] = useState<TVehicle[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    getVehiclesRecommended(city, LIMIT)
      .then((value) => {
        setVehicles(
          value.filter(
            (vehicle) => vehicle.salePrices.length > 0
          )
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [dispatch, city]);

  return (
    <section className={`${styles.VehiclesSection} dso_container_desktop p_t_xl`}>
      {(loading || (!loading && vehicles.length > 0)) && <Typography
        className="m_none m_l_md_mobile"
        weight="600"
        textColor="neutral_1000"
        scale="large"
        component="h2"
      >
        Ofertas que no puedes perder
      </Typography>}

      <div>
        {loading && (
          <RecommendedVehiclesSkeleton />
        )}
        {!loading && vehicles.length > 0 && (
          <div>
            <Swiper
              modules={[Pagination, Autoplay]}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
              slidesPerView="auto"
              centeredSlides={false}
              pagination={{ clickable: true, el: ".custom-swiper-pagination" }}
            >
              {vehicles.map((item: any, idx: number) => (
                <SwiperSlide key={`slide-${idx}`}>
                  <VehicleItem vehicle={item} />
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="custom-swiper-pagination" />
          </div>
        )}
      </div>
    </section>
  );
};

export default RecommendedVehicles;
